export const resolveSettingsDeepLink = (search = '') => {
  const params = new URLSearchParams(search);
  if (params.get('dojo-settings') === '1') return { owner: 'dojo', ...(params.get('settings') ? { section: params.get('settings') } : {}) };
  const section = params.get('settings');
  return section ? { owner: 'personal', section } : null;
};
